export default "__VITE_ASSET__9931bfef__"